import FilterValues from "./filtervalues.js";

class FilterUIHelpers {
    /**
     * Toggles the button label between the original text and the alternate text stored in the data-text attribute.
     * @param {HTMLElement} element The button element whose label is to be toggled.
     * @return {void}
     */
    toggleButtonLabel(element) {
        const label = element.innerHTML;
        element.innerHTML = element.getAttribute('data-text');
        element.setAttribute('data-text', label);
    };

    /**
     * Updates the filter count displayed on a filter element and sets the appropriate aria-label for accessibility.
     * @param {HTMLElement} element The filter element whose count is to be updated.
     * @param {number} count The new count of items for the filter.
     * @param {string} description Required when the element is a rating filter; used as the aria-label prefix.
     * @return {void}
     */
    getUpdatedFilterCount(element, count, description) {
        let label = element.innerHTML;
        const index = label.lastIndexOf('(');
        const productLabel = ' products';
        const attribute = 'aria-label';

        if (index !== -1) {
            label = label.slice(0, index);
        }

        element.innerHTML = label + '(' + count + ')';

        if (FilterValues.isRatingId(element.id)) {
            element.setAttribute(attribute, description + ' rating ' + count + productLabel);
        } else {
            element.setAttribute(attribute, label + count + productLabel);
        }
    };
}

export default new FilterUIHelpers();